import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRouter } from 'next/router';
import { Fragment, useEffect } from 'react';

import { TopLinks } from '_components/common/TopLinks';
import { Companies } from '_components/Companies';
import { usePublicAppContext } from '_core/context/public-app-context';
import { PublicApiRepo, useGetLinks } from '_core/repos/public-api.repo';
import { useTrack } from '_core/repos/track.repo';
import { FinalCTA, HeroNew, PillarSection, ProblemSection, StatsSection, TrustSection } from '_features/home/sections';
import { Catalog } from '_features/home/sections/Catalog';

export default function HomePage() {
  const { data: links } = useGetLinks(PublicApiRepo.publicApiUrl);
  const { mutateAsync: internalTrack } = useTrack();
  const { domainInfo, locale } = usePublicAppContext();
  const { t } = useTranslation(['home']);
  const router = useRouter();

  useEffect(() => {
    void internalTrack({ name: 'homeLoaded', url: location.href });
  }, []);

  return (
    <Fragment>
      <HeroNew />
      <Companies />
      <ProblemSection />
      <PillarSection type="signals" imagePosition="left" />
      <PillarSection type="marketplace" imagePosition="right" />
      <PillarSection type="outbound" imagePosition="left" />
      <StatsSection />
      <TrustSection />
      <Catalog />
      <FinalCTA />
      <TopLinks
        seeMore={t('home:sections.skills.seeMore')}
        linksIdentificationKey="home_skills"
        links={links}
        navigationData={{ origin: domainInfo?.getOriginUrl() ?? '', locale, resolvedUrl: router.asPath }}
      />
    </Fragment>
  );
}
